import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchSubServices,
  fetchSubServicesSuccess,
  fetchSubServicesFailure,
} from "../slices/subServiceSlice";

function* fetchSubServicesSaga() {
  try {
    const response = yield call(
      fetch,
      `${process.env.REACT_APP_API_URL}/v1/sub-services`,
    );

    const data = yield response.json();

    if (data.success) {
      // optional sorting
      const sortedData = data.data.sort((a, b) => a.order - b.order);

      yield put(fetchSubServicesSuccess(sortedData));
    } else {
      yield put(fetchSubServicesFailure("Failed to fetch sub services"));
    }
  } catch (error) {
    yield put(
      fetchSubServicesFailure("Error fetching sub services: " + error.message),
    );
  }
}

export function* watchSubServices() {
  yield takeLatest(fetchSubServices.type, fetchSubServicesSaga);
}
